import { getExternalConnectionAuthUrl } from '@griply/services';
import { ExternalConnectionsProviders } from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

export const getExternalAuthRedirected = async (
  provider: ExternalConnectionsProviders,
) => {
  const redirectUrl = await getExternalConnectionAuthUrl({
    functions: getFunctions(),
    httpsCallable,
    payload: { provider },
  });

  window.location.href = redirectUrl;
};
